import { createRouterSelector } from '@atlassian/react-resource-router/src/controllers/router-store';

export const useQuery = createRouterSelector((state) => state.query);
